import styled from 'styled-components';

export const CaseLeadCasesTableCellContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > button {
    background-color: transparent;
    border-color: transparent;
  }
`;

export const CaseLeadLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
